<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4" v-if="!loading" >

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">Speakers:</h2>
          </v-col>

          <v-col 
            cols="12" 
            xl="3" 
            md="3" 
            sm="12" 
            align="center"
            v-for="(speaker) in speakers" 
            :key="speaker.id">
            <cardPerson v-if="!loading" :data="speaker" :backgroundCard="speaker_background_card" />
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'speakersEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import cardPerson from '@/components/card/cardPerson'

  export default {
    name: 'newSponsorsEdition',
    components:{cardPerson},

    data: () => ({
      loading:true,

      speakers:[],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getSpeakersEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/speakers/all').then(response =>{
          this.speakers = response.data.data.speakers
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.getSpeakersEdition()
    },
  }
</script>
